import { render, staticRenderFns } from "./RankingCategoria.vue?vue&type=template&id=7a61a6d0&lang=pug"
import script from "./RankingCategoria.vue?vue&type=script&lang=js"
export * from "./RankingCategoria.vue?vue&type=script&lang=js"
import style0 from "./RankingCategoria.vue?vue&type=style&index=0&id=7a61a6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports